/* ==========================================================================
   Yumeka — page panier (/cart)
   --------------------------------------------------------------------------
   Le défaut corrigé ici : les boutons + et − ne faisaient que changer la valeur
   d'un champ `updates[]`. Rien n'écoutait, et il fallait cliquer « Mettre à
   jour » pour que les prix suivent. Personne ne le faisait, donc le panier
   affichait une quantité et un total qui ne se correspondaient plus.

   Chaque geste poste maintenant à /cart/change.js en demandant au passage le
   rendu de la section `main-cart`, et remplace le contenu de la page par ce que
   le serveur renvoie. Les montants sortent donc toujours du filtre `money` de
   Shopify : ni arithmétique en JavaScript, ni écart possible avec la caisse.

   Sans `fetch`, aucun écouteur n'est posé — le repli `<noscript>` de la section
   prend alors le relais.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.fetch || !window.Promise) return;

  var SECTION = 'main-cart';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var root = $('[data-cart-page]');
  if (!root) return;

  var lastAction = null;   // rejoué par « Réessayer »

  /* Verrou de l echange de coloris, PARTAGE entre les deux scripts.

     Changer la couleur d un cadeau se fait en deux temps : retirer la ligne,
     puis ajouter la variante voulue. Entre les deux, le panier n a plus de
     cadeau, et personne ne doit juger cet etat.

     Il a d abord ete ecrit comme une variable de fichier. Ca ne suffit pas :
     sur /cart, cart-page.js ET cart-drawer.js tournent tous les deux. La page
     levait son verrou, le tiroir gardait le sien a zero, son observateur le
     reveillait au retrait, et son addGift() rajoutait le coloris d origine.
     Trace relevee sur la boutique : change.js du Blanc, add.js du Gris, puis
     add.js du Blanc emis par post() de cart-drawer.js. Deux taies au panier.

     Le compteur vit donc sur window, seul terrain que les deux partagent.
     Un compteur et non un booleen : deux menus changes coup sur coup ne
     doivent pas voir le premier revenu lever le verrou du second. */
  function verrouEchange(delta) {
    var v = (window.__ykEchangeCadeau || 0) + (delta || 0);
    window.__ykEchangeCadeau = v > 0 ? v : 0;
    return window.__ykEchangeCadeau;
  }

  /* ---------- sur téléphone, /cart c'est le tiroir -----------------------
     La page à deux colonnes est faite pour un écran large. Sur un téléphone,
     la même information tient mieux dans le tiroir, et c'est déjà ce que la
     cliente voit quand elle touche l'icône du panier : lui présenter une
     seconde mise en page pour la même chose, selon qu'elle a touché l'icône ou
     suivi un lien, n'a aucune raison d'être.

     La page reste derrière : elle est le repli sans JavaScript, et elle
     redevient la vue normale dès qu'on referme le tiroir sur un écran large.
     Fermer le tiroir ici revient d'où l'on vient plutôt que de découvrir une
     page qu'on n'a pas demandée. */
  var petitEcran = window.matchMedia('(max-width: 899px)');

  function tiroirSurPetitEcran() {
    if (!petitEcran.matches) return;
    /* Appel direct, et non plus clic simulé sur le lien de l'en-tête. Ce clic
       dépendait d'un sélecteur, de l'ordre des écouteurs et de l'annulation
       d'un événement synthétique : il fonctionnait sur un navigateur de bureau
       et pas toujours sur téléphone, où la page restait affichée à la place du
       tiroir. */
    var tiroir = $('[data-cart-drawer]');
    if (!tiroir || !window.YumekoCart) return;
    window.YumekoCart.open();

    $$('[data-cart-close]', tiroir).forEach(function (b) {
      b.addEventListener('click', function () {
        if (window.history.length > 1) window.history.back();
        else window.location.href = '/collections/all';
      });
    });
  }

  /* Deux chemins, parce que l'ordre de chargement n'est garanti nulle part :
     si le tiroir s'est déjà annoncé on ouvre tout de suite, sinon on attend son
     signal. `once` empêche d'ouvrir deux fois. */
  if (window.YumekoCart) {
    tiroirSurPetitEcran();
  } else {
    document.addEventListener('yumeko:cart-ready', tiroirSurPetitEcran, { once: true });
  }

  /* ---------- erreur ------------------------------------------------------ */

  function showError(msg) {
    var box = $('[data-cart-error]', root);
    if (!box) { window.alert(msg); return; }
    $('[data-cart-error-text]', box).textContent = msg;
    $('[data-cart-retry]', box).hidden = !lastAction;
    box.hidden = false;
  }
  function clearError() {
    var box = $('[data-cart-error]', root);
    if (box) box.hidden = true;
  }

  /* ---------- rendu ------------------------------------------------------- */

  /* Le focus est rendu par son adresse — la ligne concernée et le rôle du
     contrôle — et non par une référence au nœud, qui disparaît au
     remplacement. Sans cela, trois pressions sur « + » renverraient le focus au
     corps du document dès la première. */
  function focusAddress() {
    var el = document.activeElement;
    if (!el || !root.contains(el)) return null;
    var line = el.closest('[data-key]');
    if (el.hasAttribute('data-cart-step')) {
      return { key: line && line.dataset.key, sel: '[data-cart-step="' + el.getAttribute('data-cart-step') + '"]' };
    }
    if (el.hasAttribute('data-cart-remove')) return { key: line && line.dataset.key, sel: '[data-cart-remove]' };
    if (el.hasAttribute('data-cart-bundle-remove')) return { key: line && line.dataset.key, sel: '[data-cart-bundle-remove]' };
    return null;
  }

  function restoreFocus(addr) {
    if (!addr || !addr.key) return;
    var scope = $('[data-key="' + addr.key + '"]', root);
    var target = scope && $(addr.sel, scope);
    /* La ligne peut avoir disparu, ou le bouton être devenu inactif quand la
       quantité tombe à 1 : on se rabat sur le premier stepper encore actif. */
    if (!target || target.disabled) {
      target = $$('[data-cart-step]:not([disabled])', root)[0];
    }
    if (target) target.focus();
  }

  function render(html) {
    var addr = focusAddress();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-page-inner]');
    var current = $('[data-cart-page-inner]', root);
    if (!fresh || !current) { window.location.reload(); return; }
    current.replaceWith(fresh);
    restoreFocus(addr);

    /* Le compteur de l'en-tête du site suit, sans quoi il continuerait
       d'annoncer l'ancienne quantité jusqu'au prochain chargement. */
    $$('[data-cart-count]').forEach(function (n) {
      n.textContent = fresh.dataset.count;
      n.hidden = fresh.dataset.count === '0';
    });

    purgeGift();
    addGift();
    initReserve();
    rafraichirTiroir();
  }

  /* Retrait des cadeaux qui n'ont rien à faire là.

     Même mécanique que dans le tiroir, et surtout même règle : le gabarit
     marque les lignes offertes dont le produit déclencheur n'est pas au panier,
     et c'est le fragment « gift-rules » qui en décide, pour les deux écrans.

     On les retire une par une : chaque retrait provoque un nouveau rendu, qui
     rejoue le contrôle sur le panier recalculé par le serveur. Le compteur
     borne la boucle — un panier figé se voit, une boucle ne se voit pas. */
  var purgeTries = 0;

  function purgeGift() {
    if (verrouEchange(0) > 0) return;
    var inner = $('[data-cart-page-inner]', root);
    if (!inner) return;
    var keys = (inner.getAttribute('data-cart-gift-purge') || '').split(',').filter(Boolean);
    if (!keys.length) { purgeTries = 0; return; }
    if (++purgeTries > 6) return;
    post('/cart/change.js', { id: keys[0], quantity: 0 });
  }

  /* Ajout du cadeau, meme regle et meme mecanique que dans le tiroir. */
  var addTries = 0;

  function addGift() {
    /* Le cadeau est absent parce qu on vient de le retirer pour le remplacer.
       Le rajouter ici, c est en livrer deux. */
    if (verrouEchange(0) > 0) return;
    var inner = $('[data-cart-page-inner]', root);
    if (!inner) return;
    var id = inner.getAttribute('data-cart-gift-add');
    if (!id) { addTries = 0; return; }
    if (++addTries > 3) return;
    post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
  }

  function post(url, body, busy) {
    lastAction = function () { post(url, body, busy); };
    clearError();
    if (busy) busy.classList.add('is-busy');
    body.sections = SECTION;
    body.sections_url = window.location.pathname;

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        /* La reponse est lue en TEXTE avant d etre analysee.

           r.json() sur une page HTML jette « Unexpected token '<' … is not
           valid JSON », et ce message partait tel quel dans le bandeau du
           tiroir : la cliente lisait une erreur de parseur, et nous
           n apprenions rien de la panne.

           Du HTML sur /cart/*.js veut dire que la requete n a pas atteint
           l API du panier : page de mot de passe, session expiree, controle
           anti-robot, ou le proxy de `shopify theme dev`. Aucun de ces cas
           ne se repare en reessayant le meme appel — le message le dit, et
           donne le code renvoye pour qu on sache lequel c est. */
        return r.text().then(function (t) {
          var b;
          try { b = JSON.parse(t); }
          catch (e) {
            throw new Error('Le panier n’a pas répondu (' + r.status + '). Rechargez la page.');
          }
          if (!r.ok) throw new Error(b.description || b.message || b.errors || 'Mise à jour impossible.');
          return b;
        });
      })
      .then(function (data) {
        lastAction = null;
        /* Le panier a bien ete modifie ; c est le rendu de la section qui
           manque. Recharger vaut mieux que laisser l ecran afficher un etat
           qui n est plus vrai. */
        if (!data.sections || !data.sections[SECTION]) { window.location.reload(); return; }
        render(data.sections[SECTION]);
      })
      .catch(function (err) {
        if (busy) busy.classList.remove('is-busy');
        showError(err.message === 'Failed to fetch'
          ? 'Connexion perdue. Le panier n’a pas été modifié.'
          : err.message);
      });
  }

  /* ---------- actions ----------------------------------------------------- */

  root.addEventListener('click', function (e) {
    var t = e.target;

    var bundleRemove = t.closest('[data-cart-bundle-remove]');
    if (bundleRemove) {
      var bundleRow = bundleRemove.closest('[data-key]');
      /* Les lignes du pack sont retrouvees MAINTENANT, par leur produit.

         Les cles rendues par Liquid perimaient : changer le coloris du cadeau
         remplace la ligne et lui donne une nouvelle cle. update.js repondait
         alors 200 sans rien retirer, et la corbeille paraissait morte.
         Constate sur la boutique : deux cles d oreiller valides, une cle de
         taie perimee, et le pack restait entier au panier.

         Les identifiants de produit, eux, survivent a tout echange. Les cles
         du gabarit ne servent plus que de repli si /cart.js ne repond pas. */
      var repli = (bundleRemove.getAttribute('data-cart-bundle-keys') || '').split(',').filter(Boolean);
      var produits = (bundleRemove.getAttribute('data-cart-bundle-products') || '').split(',').filter(Boolean);
      var partir = function (updates) {
        if (!Object.keys(updates).length) { bundleRow.classList.remove('is-busy'); return; }
        post('/cart/update.js', { updates: updates }, bundleRow);
      };
      var parRepli = function () { var u = {}; repli.forEach(function (k) { u[k] = 0; }); return u; };
      bundleRow.classList.add('is-busy');
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (panier) {
          var u = {};
          if (panier && produits.length) {
            panier.items.forEach(function (it) {
              if (produits.indexOf(String(it.product_id)) !== -1) u[it.key] = 0;
            });
          }
          partir(Object.keys(u).length ? u : parRepli());
        })
        .catch(function () { partir(parRepli()); });
      return;
    }

    var step = t.closest('[data-cart-step]');
    if (step) {
      var line = step.closest('[data-key]');
      var now = parseInt($('[data-cart-count-line]', line).textContent, 10) || 0;
      var next = now + parseInt(step.getAttribute('data-cart-step'), 10);
      line.classList.add('is-busy');
      post('/cart/change.js', { id: line.dataset.key, quantity: Math.max(next, 0) }, line);
      return;
    }

    /* Vider le panier, meme geste et meme confirmation que dans le tiroir. */
    var vider = t.closest('[data-cart-clear]');
    if (vider) {
      if (!window.confirm('Vider le panier ?')) return;
      post('/cart/clear.js', {}, vider);
      return;
    }

    var rm = t.closest('[data-cart-remove]');
    if (rm) {
      var row = rm.closest('[data-key]');
      row.classList.add('is-busy');
      post('/cart/change.js', { id: row.dataset.key, quantity: 0 }, row);
      return;
    }

    var retry = t.closest('[data-cart-retry]');
    if (retry && lastAction) { var again = lastAction; lastAction = null; again(); }
  });

  /* La note part avec le formulaire de paiement, mais si la cliente la saisit
     puis quitte la page sans passer commande, elle serait perdue. On
     l'enregistre à la sortie du champ. */
  /* Changement de coloris sur une ligne offerte, meme mecanique qu'au tiroir.

     L'API du panier ne remplace pas une variante : elle ne sait que changer une
     quantite. On retire donc la ligne, puis on ajoute la variante voulue dans
     la meme quantite. Retirer d'abord, jamais l'inverse : ajouter en premier
     ferait cohabiter deux cadeaux le temps d'un rendu. */
  root.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-gift-variant]') : null;
    if (!sel) return;
    var cle = sel.getAttribute('data-key');
    var qte = parseInt(sel.getAttribute('data-qty'), 10) || 1;
    var id = parseInt(sel.value, 10);
    if (!cle || !id) return;
    // Le <select> porte lui aussi data-key : closest('[data-key]') le
    // renvoyait lui-meme au lieu de la ligne. On vise la ligne par sa classe.
    var ligne = sel.closest('.ykb, .ycp__item');
    if (ligne) ligne.classList.add('is-busy');
    /* Un seul rendu, pas deux. Le retrait part SANS demander la section : le
       rendu intermediaire affichait le panier ampute de son cadeau pendant une
       fraction de seconde, ce qui se lit comme une reinitialisation. Seul
       l'ajout ramene le nouveau balisage. */
    /* Si l echange n aboutit ni en succes ni en erreur -- onglet endormi,
       reseau muet -- le verrou resterait leve et le panier cesserait de se
       resynchroniser. Il tombe seul au bout de dix secondes. */
    verrouEchange(1);
    var verrouRelache = false;
    var finEchange = function () { if (verrouRelache) return; verrouRelache = true; verrouEchange(-1); };
    setTimeout(finEchange, 10000);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: cle, quantity: 0 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Changement impossible.');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: qte }] })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Ajout impossible.');
        /* Pas de post() ici, et c est le coeur du correctif.

           post() redessine, et redessiner rejoue le garde-fou cadeau. Je
           levais le verrou juste avant : le garde-fou voyait alors un panier
           qu il jugeait incomplet et ajoutait un exemplaire de plus. Mesure
           sur la boutique apres un changement de coloris : 2x Blanc au lieu
           de 1, et un article de plus au panier.

           Le verrou tombe donc APRES l ajout, et c est resynchroniser() qui
           redessine -- il compare d abord, et ne redessine que s il y a un
           ecart reel. Meme mecanique que dans le tiroir, qui ne re-rend pas
           non plus au retour de l echange. */
        finEchange();
        if (ligne) ligne.classList.remove('is-busy');
        return resynchroniser();
      })
      .catch(function () {
        finEchange();
        if (ligne) ligne.classList.remove('is-busy');
        showError('Ce coloris n’a pas pu être appliqué.');
      });
  });

  root.addEventListener('change', function (e) {
    var note = e.target.closest('#cart-note');
    if (!note) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note: note.value })
    }).catch(function () { /* sans conséquence : la note repart avec le formulaire */ });
  });
  /* Au chargement de la page, et pas seulement apres une modification.

     purgeGift et addGift n etaient appeles que depuis render(), qui ne tourne
     qu au retour d un post. Le gabarit demandait donc bien l ajout des la
     premiere page — l attribut etait la — mais personne ne le lisait tant que
     la cliente ne touchait pas a une quantite. Vu sur la boutique : panier de
     deux oreillers, data-cart-gift-add rendu, et aucun cadeau ajoute.

     L instruction du serveur doit etre executee des qu elle est rendue, pas
     seulement quand quelque chose d autre la reveille. */
  /* Decompte, porte du tiroir a l identique.

     Deux horloges, selon que le decompte doit survivre au rechargement. Sans
     persistance, performance.now() compte des millisecondes ecoulees et non une
     heure : une horloge locale dereglee n a aucun effet, mais le decompte repart
     a chaque chargement. Avec, une echeance absolue est rangee dans le
     sessionStorage de l onglet et Date.now() la vise.

     Ce que la persistance ne change pas : aucun stock n est immobilise, et
     l echeance est fabriquee par le navigateur, pas par le serveur. */
  var reserveId = null;

  function initReserve() {
    if (reserveId) { clearInterval(reserveId); reserveId = null; }
    var band = $('[data-cart-reserve]', root);
    if (!band) return;
    var total = parseInt(band.getAttribute('data-cart-reserve'), 10);
    if (!(total > 0)) return;
    var mEl = $('[data-m]', band), sEl = $('[data-s]', band);
    if (!mEl || !sEl) return;

    var keep = band.getAttribute('data-cart-reserve-keep') === '1';
    var anchor = performance.now();
    var due = 0;

    if (keep) {
      /* Meme cle que le tiroir : passer de la page au tiroir ne doit pas
         relancer le decompte, sans quoi il se contredirait d un ecran a
         l autre sous les yeux de la cliente. */
      var KEY = 'ycd-reserve-due';
      try {
        var saved = parseInt(sessionStorage.getItem(KEY), 10);
        if (saved > Date.now() && saved - Date.now() <= total * 1000) due = saved;
        if (!due) {
          due = Date.now() + total * 1000;
          sessionStorage.setItem(KEY, String(due));
        }
      } catch (e) { keep = false; }
    }

    function tick() {
      var left = keep
        ? Math.max(0, Math.round((due - Date.now()) / 1000))
        : Math.max(0, Math.round(total - (performance.now() - anchor) / 1000));
      if (left <= 0) {
        clearInterval(reserveId);
        reserveId = null;
        band.remove();
        return;
      }
      mEl.textContent = ('0' + Math.floor(left / 60)).slice(-2);
      sEl.textContent = ('0' + (left % 60)).slice(-2);
    }
    tick();
    reserveId = setInterval(tick, 1000);
  }

  /* Sur petit ecran c est le tiroir qu on voit, et c est lui qui s en charge :
     rafraichir ici le conteneur de la page ne montrerait rien a personne. */
  if (!petitEcran.matches) {
    purgeGift();
    addGift();
  }
  initReserve();

  /* ---------- resynchronisation ------------------------------------------ */

  /* Le panier peut changer sans que ce script le sache.

     BundleX depose les taies offertes par un appel qui lui est propre, une
     a deux secondes APRES que le serveur a rendu la page. Mesure sur la
     boutique : /cart.js portait les quatre taies, et l ecran n affichait pas
     la carte cadeau. La cliente lisait un panier qui n existait plus.

     Le meme ecart tue le paiement. Shopify renvoie une caisse vide vers
     l accueil, sans un mot : panier vide par la corbeille, bouton de
     paiement encore affiche avec l ancien montant, et la cliente se retrouve
     sur la page d accueil sans comprendre. C est la deuxieme moitie du
     defaut signale sur iPhone, et c est la meme cause.

     On compare donc le compte affiche a celui du serveur, et on redessine
     quand ils different. Une comparaison, pas une horloge : rien ne tourne
     en fond, et un panier deja juste ne coute qu un appel a /cart.js. */
  function compteAffiche() {
    var n = $('[data-cart-page-inner]', root) || $('[data-cart-inner]', root);
    if (!n) return null;
    var v = parseInt(n.getAttribute('data-count'), 10);
    return isNaN(v) ? null : v;
  }

  function resynchroniser() {
    /* Pendant un echange de coloris le panier est a mi-chemin : le comparer
       a l ecran n a aucun sens, et redessiner ferait rejouer le garde-fou
       cadeau sur un panier incomplet. */
    if (verrouEchange(0) > 0) return Promise.resolve(null);
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || compteAffiche() === c.item_count) return c;
        /* Sans en-tete Accept, et c est deliberé : avec `Accept: application/json`,
           Shopify repond le PANIER (token, items, totaux) et ignore ?sections=.
           La reponse etait donc toujours valide, jamais la bonne, et le silence
           etait total -- s[SECTION] valait undefined, on ne redessinait rien. */
        return fetch(window.location.pathname + '?sections=' + SECTION)
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (s) { if (s && s[SECTION]) render(s[SECTION]); return c; });
      })
      .catch(function () { return null; });
  }

  /* Safari garde la page en cache quand on revient en arriere : elle
     reapparait telle qu on l avait laissee, panier compris. `persisted` ne
     vaut vrai que dans ce cas precis. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) resynchroniser(); });

  /* Le tiroir et la page panier montrent le MEME panier.

     Sur /cart, le tiroir s ouvre par-dessus la page. Chaque script ne
     redessinait que sa propre surface : la corbeille du tiroir vidait le
     tiroir, et en le fermant la cliente retrouvait la page telle qu avant,
     avec les articles qu elle venait de retirer. Mesure sur la boutique,
     tiroir a zero article et page a quatre, en meme temps.

     On redessine donc l autre surface aussi, quand elle est la. Echange de
     noeud seulement : pas de garde-fou cadeau, pas de decompte relance. Ces
     decisions appartiennent au script qui possede la surface, et deux
     scripts qui les prendraient tous les deux se marcheraient dessus. */
  function rafraichirTiroir() {
    if (!document.querySelector('[data-cart-inner]')) return;
    /* Sans en-tete Accept, et c est deliberé : avec `Accept: application/json`,
       Shopify repond le PANIER (token, items, totaux) et ignore ?sections=.
       La reponse etait donc toujours valide, jamais la bonne, et le silence
       etait total -- s[SECTION] valait undefined, on ne redessinait rien. */
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (s) {
        if (!s || !s['cart-drawer']) return;
        var doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
        var frais = doc.querySelector('[data-cart-inner]');
        var actuel = document.querySelector('[data-cart-inner]');
        if (frais && actuel) actuel.replaceWith(frais);
      })
      .catch(function () { /* l autre surface n est pas la vue courante */ });
  }

  /* Trois controles espaces, puis plus rien.

     L observateur ci-dessus ne voit que ce qui passe par fetch. Le cadeau de
     BundleX, lui, apparait SANS aucune requete observable depuis la page :
     mesure sur la boutique, /cart rendu a quatre articles, /cart.js a cinq,
     et pas un appel entre les deux. La mutation est faite ailleurs — cote
     serveur, ou par un transport qu on n instrumente pas. Aucun crochet
     client ne peut l apprendre : il faut aller demander.

     Trois demandes, a une seconde, deux et demie et quatre secondes et demie.
     Bornees, parce qu un panier qui n a pas bouge au bout de cinq secondes
     ne bougera plus, et qu une boucle sans fin coute a la cliente sa batterie
     et a nous notre quota. Chaque demande est un /cart.js ; le rendu de
     section n est demande que si les comptes different vraiment. */
  [900, 2200, 4500].forEach(function (d) { setTimeout(resynchroniser, d); });

  /* Redessiner quand QUELQU UN D AUTRE touche au panier.

     Un delai devine ne marche pas : j avais pose un second controle a
     1500 ms, et BundleX deposait son cadeau apres. Mesure sur la boutique,
     l ecran restait a quatre articles pendant que le panier en portait cinq.

     On ecoute donc l evenement lui-meme. Toute requete qui MODIFIE le panier
     — d ou qu elle vienne, application comprise — declenche une comparaison
     au tour suivant. Nos propres appels la declenchent aussi : ils ont deja
     redessine, la comparaison ne trouve rien et coute un /cart.js.

     fetch est enveloppe, jamais remplace : l appel d origine passe intact,
     et une erreur de notre cote ne doit pas emporter la requete. */
  if (window.fetch.__yk !== true) {
    var fetchOrigine = window.fetch;
    var enveloppe = function (u, o) {
      var p = fetchOrigine.apply(this, arguments);
      try {
        var url = typeof u === 'string' ? u : (u && u.url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
          p.then(function (r) { if (r && r.ok) setTimeout(resynchroniser, 0); })
           .catch(function () {});
        }
      } catch (e) { /* l enveloppe ne casse jamais la requete */ }
      return p;
    };
    enveloppe.__yk = true;
    window.fetch = enveloppe;
  }

  /* Et au chargement, pas seulement au retour arriere.

     Le tiroir se resynchronise a son ouverture ; la page, elle, n a pas
     d ouverture -- elle est simplement la. Sans ce controle elle restait
     figee sur le rendu du serveur : mesure sur la boutique, /cart affichait
     quatre articles et aucune carte cadeau pendant que le panier en portait
     cinq, taies comprises. Le second passage couvre la fenetre pendant
     laquelle BundleX depose son cadeau. */
  resynchroniser();

  /* Aucun panier vide n atteint la caisse.

     form.submit() n emporte pas le nom du bouton qui a declenche l envoi :
     sans ce champ cache, le formulaire posterait sur /cart sans `checkout`
     et ne partirait jamais au paiement. */
  root.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest ? e.target.closest('[data-cart-checkout]') : null;
    if (!f || f.getAttribute('data-verifie') === '1') return;
    e.preventDefault();
    function partir() {
      f.setAttribute('data-verifie', '1');
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'checkout'; h.value = '';
      f.appendChild(h);
      f.submit();
    }
    resynchroniser().then(function (c) {
      /* Serveur injoignable : on laisse partir plutot que de bloquer une
         vente sur une incertitude. */
      if (!c) { partir(); return; }
      if (c.item_count === 0) { showError('Votre panier est vide.'); resynchroniser(); return; }
      partir();
    });
  });
})();
